import { render, staticRenderFns } from "./v-menu-multi-level.vue?vue&type=template&id=4636fd9a&scoped=true"
import script from "./v-menu-multi-level.vue?vue&type=script&lang=js"
export * from "./v-menu-multi-level.vue?vue&type=script&lang=js"
import style0 from "./v-menu-multi-level.vue?vue&type=style&index=0&id=4636fd9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636fd9a",
  null
  
)

export default component.exports